module.exports = __webpack_public_path__ + "img/new_index_customers6.8c942a53.png";